import { useContext } from "react"
import { ReferencesContext } from "./ReferencesContext"
import type { ReferencesContextValue } from "./ReferencesContextValue"

export function useReferencesContext(): ReferencesContextValue {
  return useContext(ReferencesContext)
}
